import { SEARCH_BOOK, STATUS_CHANGE } from "./actionTypes";

const initialState = {
    status: "All",
    searchKeyword: "",

}

const filterReducer = (state=initialState, action) => {
    switch (action.type) {
        case STATUS_CHANGE:
            return {
                ...state,
                status: action.payload,
            }
        
        case SEARCH_BOOK:
            return {
                ...state,
                searchKeyword: action.payload
            }
    
        default:
            return state
    }
}


export default filterReducer;